import React, { createContext, useCallback, useContext, useState } from "react";

const BookDemoContext = createContext(null);

export function BookDemoProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openBookDemo = useCallback(() => setOpen(true), []);

  return (
    <BookDemoContext.Provider value={{ open, setOpen, openBookDemo }}>
      {children}
    </BookDemoContext.Provider>
  );
}

export function useBookDemo() {
  const ctx = useContext(BookDemoContext);
  if (!ctx) {
    throw new Error("useBookDemo must be used within BookDemoProvider");
  }
  return ctx;
}
